// Quotation Approved Stage  Btn related codes

// NPM Imports
import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Toastr, Button, Input } from "@revvsales/components";
import ReactHtmlParser from "react-html-parser";

import PreviewDocument from "../../QuotationTopbar/QuotationTopbarBtns/PreviewDocument";

// Service Imports
import { cloneDocumentService } from "../../../actions/DocumentActions/services";

// import { MeteredCounter } from "../../../commonComponents";
import ReferralPopup from "../../SettingsWrapper/ReferralPopup";
import QuickReviewIcon from "../../QuickReview/QuickReviewIcon";
// import ExportDocumentBtn from "../../QuotationTopbar/QuotationTopbarBtns/ExportDocumentBtn";
// import SendForReview from "../../QuotationTopbar/QuotationTopbarBtns/SendForReview";
import { GlobalUtils, AmplitudeUtils, DocumentUtils } from "../../../utils";
import { EVENTS } from "../../../constants";
// import { USER_ROLES } from "../../../constants/roleList";

import DocToTemplatePopup from "./DocToTemplate/DocToTemplatePopup";
import DocToTemplateBtn from "./DocToTemplate/DocToTemplateBtn";
import saveDocAsTemplate from "./DocToTemplate/methods";

// import SendForSignature from "./SendForSignature";
// import UploadRevision from "./UploadRevision";

// Internal Imports
// import { FEATURES } from "../../../constants";

// Actions Imports
import { QuotationActions } from "../../../actions";

// Image Imports
import ESIGN_TOOLTIP_PNG from "../../../assets/TT-Send-for-eSign.png";
import SNAPLINK_PNG from "../../../assets/TT-Snaplink.png";
import MAGICLINK_PNG from "../../../assets/TT-Magic-Link.png";
import SEND_TO_SOMEONE_PNG from "../../../assets/TT-Send-to-somone.png";
import SEND_FOR_ACCEPTANCE from "../../../assets/TT-Send-for-Acceptance.png";
import SEND_FOR_PAYMENT_PNG from "../../../assets/TT-Send-for-Payment.png";
import SEND_FOR_APPROVAL_PNG from "../../../assets/TT-Send-for-Approval.png";

// Destructuring
// const { FEATURES_NAME } = FEATURES;
const { amplitudeLogEvent } = AmplitudeUtils;
const {
  copyToClipBoard,
  handleApiErrMsg,
  readDataFromLocalStorage,
} = GlobalUtils;
const { snaplinkGeneratedInfo } = DocumentUtils;
const { updateToolPaneData } = QuotationActions;

class QuotationApprovedBtns extends Component {
  static documentHTMLData = "";

  state = {
    showMenu: false,
    showDocPreview: false,
    showRenamePopup: false,
    showReferralPopup: false,
    templateName: `${this.props.docName} Template`,
    showShareOptions: false,
    showMoreOptions: false,
  };

  createExportRef = element => {
    this.exportRef = element;
  };

  createSendRef = element => {
    this.sendRef = element;
  };

  createShareRef = element => {
    this.shareRef = element;
  };

  componentWillMount = () => {
    document.addEventListener("mousedown", this.handleClick, false);
  };

  componentWillUnMount = () => {
    document.removeEventListener("mousedown", this.handleClick, false);
  };

  showMenu = event => {
    event.preventDefault();
    const { showMenu } = this.state;
    this.setState({
      showMenu: !showMenu,
      showShareOptions: false,
      showMoreOptions: false,
    });
  };

  showShareOptions = event => {
    event.preventDefault();
    const { showShareOptions } = this.state;
    if (!showShareOptions) {
      const objectId = this.props.docObjectId;
      const objectType = "DOC";
      this.props.getPermaLinkData(objectId, objectType);
      this.props.getSnapLinkData(objectId, objectType);
    }
    this.setState({
      showShareOptions: !showShareOptions,
      showMoreOptions: false,
      showMenu: false,
    });
  };

  showMoreOptions = event => {
    event.preventDefault();
    const { showMoreOptions } = this.state;
    this.setState({
      showMoreOptions: !showMoreOptions,
      showShareOptions: false,
      showMenu: false,
    });
  };

  _handleCopyLink = data => {
    if (copyToClipBoard(data)) {
      Toastr.showToastr({
        type: "success",
        message: "Copied Successfully",
        timeout: 3000,
      });
    } else {
      Toastr.showToastr({
        type: "failure",
        message: "Error while copying!...",
        timeout: 3000,
      });
    }
  };

  handleClick = e => {
    if (
      (this.exportRef && this.exportRef.contains(e.target)) ||
      (this.sendRef && this.sendRef.contains(e.target)) ||
      (this.shareRef && this.shareRef.contains(e.target))
    ) {
      return;
    }
    this.setState({
      showMenu: false,
      showShareOptions: false,
      showMoreOptions: false,
    });
  };

  _handleOptionList = value => {
    if (value === "approval") {
      this.setState({ showMenu: false });
    } else if (value === "reviewer") {
      amplitudeLogEvent(EVENTS.EVENT_NAMES.SHARE_DOCUMENT_CLICKED, {
        status: this.props.documentStatus && this.props.documentStatus.name,
        tag: this.props.documentTag && this.props.documentTag.name,
        DocumentID: this.props.docID,
        CTA: "Send To Someone",
      });
      this.props.togglePopUp("showAddRecipientsPopup", true, "forReviewer");
      this.setState({ showMenu: false });
      // } else if (value === "invite") {
      //   amplitudeLogEvent(EVENTS.EVENT_NAMES.SHARE_DOCUMENT_CLICKED, {
      //     status: this.props.documentStatus && this.props.documentStatus.name,
      //     tag: this.props.documentTag && this.props.documentTag.name,
      //     DocumentID: this.props.docID,
      //     CTA: "Invite People",
      //   });
      //   this.props.togglePopUp("showAddRecipientsPopup", true, "forReviewer");
      //   this.setState({ showMenu: false });
    } else if (value === "acceptance") {
      this.props.togglePopUp("addAcceptorList", true, "forAcceptance");
      this.setState({ showMenu: false });
    } else if (value === "esign") {
      this.props.togglePopUp("signerDetails", true, "eSign");
    } else if (value === "reffer") {
      this._toggleNavbarPopup("showReferralPopup", true);
      this.setState({ showMoreOptions: false });
    } else if (value === "invite") {
      this.props.togglePopUp("showTeammatePopup", true);
      this.setState({ showMoreOptions: false });
    } else if (value === "metalense") {
      this.setState({ showMoreOptions: false });
      this.props.updateToolPaneData(true, "quick-review");
    } else if (value === "download") {
      this.props.togglePopUp("download", true);
      this.setState({ showMoreOptions: false });
    } else if (value === "editDocument") {
      this.props.togglePopUp("showConfirmMoveToDraftPopup", true);
      this.setState({ showMoreOptions: false });
    } else if (value === "payment") {
      this.props.togglePopUp("checkPaymentButtons", true, "stripePayment");
    }
  };

  _toggleDocPreviewPopUp = () => {
    const documentSectionHTML = document.getElementsByClassName(
      "document-view-main-container",
    )[0];
    QuotationApprovedBtns.documentHTMLData =
      documentSectionHTML && documentSectionHTML.innerHTML.length > 0
        ? documentSectionHTML.innerHTML
        : "";
    this.setState(prevState => ({
      showDocPreview: !prevState.showDocPreview,
      showMenu: false,
    }));
  };

  _toggleNavbarPopup = (type, flag) => {
    this.setState({ [type]: flag });
  };

  _cloneDocument = () => {
    cloneDocumentService(this.props.docID)
      .then(response => {
        const message = "Document successfully cloned";
        Toastr.showToastr({
          type: "failure",
          message,
          timeout: 2000,
        });
        this.setState({
          showMoreOptions: false,
        });
        const currentUrl = this.removeLastDirectoryPartOf(window.location.href);
        window.open(`${currentUrl}/${response.Document.doc_no}`);
      })
      .catch(error => {
        this.setState({
          showMoreOptions: false,
        });
        const message = handleApiErrMsg(error);
        Toastr.showToastr({
          type: "failure",
          message,
          timeout: 2000,
        });
      });
  };

  handleTemplateName = e => {
    this.setState({
      templateName: e.target.value,
    });
  };

  removeLastDirectoryPartOf = url => {
    const newUrl = url.split("/");
    newUrl.pop();
    return newUrl.join("/");
  };

  toggleDocToTemplatePopup = () => {
    this.setState(prevState => ({
      showRenamePopup: !prevState.showRenamePopup,
    }));
  };

  setStateToInitial = () => {
    this.setState({
      showRenamePopup: false,
      templateName: `${this.props.docName} Template`,
    });
  };

  onSave = () => {
    if (this.state.templateName) {
      saveDocAsTemplate(
        this.props.docID,
        this.state.templateName,
        this.setStateToInitial,
      );
    } else {
      const message = "Template name is required";
      Toastr.showToastr({
        type: "failure",
        message,
        timeout: 2000,
      });
    }
  };

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    let popupSpace = null;

    if (this.state.showRenamePopup && !this.props.isPdfDocument) {
      return (
        <DocToTemplatePopup
          togglePopup={this.toggleDocToTemplatePopup}
          handleTemplateName={this.handleTemplateName}
          templateName={this.state.templateName}
          saveDocAsTemplate={this.onSave}
        />
      );
    }
    if (this.state.showRenamePopup && this.props.isPdfDocument) {
      Toastr.showToastr({
        type: "warning",
        message: "Only .docx files can be saved as templates.",
        timeout: 3000,
      });
      this.setState({
        showRenamePopup: false,
      });
    }
    if (this.state.showReferralPopup) {
      popupSpace = <ReferralPopup closePopup={this._toggleNavbarPopup} />;
    }

    return (
      <Fragment>
        {popupSpace}
        {/* 
        {CURRENT_USER.roles[0].name === USER_ROLES.ADMIN && (
         {popupSpace}
          <Fragment>
            <div>
              <Tooltip placement="bottom" overlay="Invite team members to Revv">
                <span
                  className="user-role-wrapper"
                  onClick={() =>
                    this.props.togglePopUp("showTeammatePopup", true)
                  }
                  onKeyPress={() => {}}
                  tabIndex="0"
                  role="button">
                  <FontAwesomeIcon icon={["fas", "user-plus"]} />
                </span>
              </Tooltip>
            </div>
          )}
          <div className="user-invite-line" />
        </Fragment>

        <Button
          className="revv-btn-esign"
          onClick={() => this.props.togglePopUp("signerDetails", true, "eSign")}
          id={"signerDetails".replace(/ +/g, "-").toLowerCase()}
          data-test="quotation-approved-btns-esign">
          <FontAwesomeIcon
            icon={["far", "signature"]}
            className="documentrecipientlist-role-icon"
          />
          &nbsp; eSign
        </Button>
       <SendForReview {...this.props} /> */}
        <div>
          <div className="btn-export-wrapper" ref={this.createSendRef}>
            <Tooltip
              align={{
                offset: [0, 4],
              }}
              placement="bottom"
              overlay="Share and send documents">
              <Button
                type="one"
                className="analyse-document"
                data-test="quotation-draft-btns-send"
                onClick={this.showMenu}>
                Send document
                <i
                  className={`ic-dropdown ${
                    this.state.showMenu ? "dropdown-open" : ""
                  }`}>
                  <FontAwesomeIcon
                    icon={["far", "angle-down"]}
                    className="documentrecipientlist-role-icon"
                  />
                </i>
              </Button>
            </Tooltip>
            {this.state.showMenu && (
              <div className="export-dropdown sending-docs">
                <ul className="export-dd-items">
                  <li>
                    <Tooltip
                      placement="left"
                      overlay="Recipients get an email with document link and a request to <b>review and collaborate.</b>"
                      imgUrl={SEND_TO_SOMEONE_PNG}
                      imgAltTxt="send-for-acceptance">
                      <div
                        data-test="cta-send-to-someone-button"
                        className="send-list-item"
                        role="button"
                        tabIndex="0"
                        onClick={() => this._handleOptionList("reviewer")}
                        onKeyPress={() => this._handleOptionList("reviewer")}>
                        <div className="btn-send-icon">
                          <FontAwesomeIcon
                            icon={["far", "paper-plane"]}
                            className="documentrecipientlist-role-icon"
                          />
                        </div>
                        <div>
                          <div className="btn-send-heading">
                            Send to someone
                          </div>
                          <div className="btn-send-desc">
                            {`Send document to recipient's email and give them
                              view or edit access.`}
                          </div>
                        </div>
                      </div>
                    </Tooltip>
                  </li>
                  <li>
                    <Tooltip
                      placement="left"
                      overlay="Recipients get an email with document link requesting them to <b>eSign or fill and eSign documents.</b>"
                      imgUrl={ESIGN_TOOLTIP_PNG}
                      imgAltTxt="send-for-acceptance">
                      <div
                        data-test="cta-send-for-esign-button"
                        className="send-list-item"
                        role="button"
                        tabIndex="0"
                        onClick={() => this._handleOptionList("esign")}
                        onKeyPress={() => this._handleOptionList("esign")}>
                        <div className="btn-send-icon">
                          <FontAwesomeIcon
                            icon={["far", "signature"]}
                            className="documentrecipientlist-role-icon"
                          />
                        </div>
                        <div>
                          <div className="btn-send-heading">Send for eSign</div>
                          <div className="btn-send-desc">
                            Initiate eSignature process for signers already
                            added in the document.
                          </div>
                        </div>
                        <div className="btn-recommend">Recommended</div>
                      </div>
                    </Tooltip>
                  </li>
                  {!this.props.isPdfDocument && (
                    <li>
                      <Tooltip
                        placement="left"
                        overlay="Recipients get an email with document link. They can click on <b>payment button on the document to pay.</b>"
                        imgUrl={SEND_FOR_PAYMENT_PNG}
                        imgAltTxt="send-for-acceptance">
                        <div
                          data-test="cta-send-for-payment-button"
                          className="send-list-item"
                          role="button"
                          tabIndex="0"
                          onClick={() => this._handleOptionList("payment")}
                          onKeyPress={() => {}}>
                          <div className="btn-send-icon">
                            <FontAwesomeIcon
                              icon={["far", "money-check-alt"]}
                              className="documentrecipientlist-role-icon"
                            />
                          </div>
                          <div>
                            <div className="btn-send-heading">
                              Send for payment
                            </div>
                            <div className="btn-send-desc">
                              Add payment blocks and share document to collect
                              payments instantly.
                            </div>
                          </div>
                        </div>
                      </Tooltip>
                    </li>
                  )}
                  <li>
                    <Tooltip
                      placement="left"
                      overlay="Recipients get an email with document link requesting them to give their <b>consent by accepting or rejecting</b> the document."
                      imgUrl={SEND_FOR_ACCEPTANCE}
                      imgAltTxt="send-for-acceptance">
                      <div
                        data-test="cta-send-for-acceptance-button"
                        className="send-list-item"
                        role="button"
                        tabIndex="0"
                        onClick={() => this._handleOptionList("acceptance")}
                        onKeyPress={() => this._handleOptionList("acceptance")}>
                        <div className="btn-send-icon">
                          <FontAwesomeIcon
                            icon={["far", "user-check"]}
                            className="documentrecipientlist-role-icon"
                          />
                        </div>
                        <div>
                          <div className="btn-send-heading">
                            Send for acceptance
                          </div>
                          <div className="btn-send-desc">
                            Get consent from recipients by requesting them to
                            accept or reject document.
                          </div>
                        </div>
                      </div>
                    </Tooltip>
                  </li>

                  {/* <li>
                    <div
                      className="send-list-item"
                      role="button"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("invite")}
                      onKeyPress={() => this._handleOptionList("invite")}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "user-friends"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading">Invite people </div>
                        <div className="btn-send-desc">
                          Collaborate privately with others
                        </div>
                      </div>
                    </div>
                  </li> */}
                  {!this.props.isPdfDocument && (
                    <li>
                      <Tooltip
                        placement="left"
                        align={{
                          offset: [0, 4],
                        }}
                        overlay="Document already approved."
                        imgUrl={SEND_FOR_APPROVAL_PNG}
                        imgAltTxt="send-for-acceptance">
                        <div
                          data-test="cta-send-for-internal-approval-button"
                          className="send-list-item inactive"
                          role="button"
                          tabIndex="0"
                          onClick={() => this._handleOptionList("approval")}
                          onKeyPress={() => this._handleOptionList("approval")}>
                          <div className="btn-send-icon">
                            <FontAwesomeIcon
                              icon={["far", "comment-alt-check"]}
                              className="documentrecipientlist-role-icon"
                            />
                          </div>
                          <div>
                            <div className="btn-send-heading">
                              Check and send for internal approval
                            </div>
                            <div className="btn-send-desc">
                              Check for triggered approval workflows and get
                              these approvals from colleagues.
                            </div>
                          </div>
                        </div>
                      </Tooltip>
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
        {/** POPUP SECTION */}
        {this.state.showDocPreview && (
          <PreviewDocument
            togglePopUp={this._toggleDocPreviewPopUp}
            html={QuotationApprovedBtns.documentHTMLData}
          />
        )}
        {/* <Button
          className="analyse-document"
          onClick={() =>
            this.props.togglePopUp(
              "showAddRecipientsPopup",
              true,
              "forReviewer",
            )
          }
          id={"Send for review".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationTopbar-upgrade-stage-btn">
          Send for review
        </Button> */}
        {/* <div className="meter-section">
          <SendForSignature {...this.props} />
        </div> */}
        <div>
          <div className="btn-export-wrapper" ref={this.createShareRef}>
            <Tooltip placement="bottom" overlay="Share link or publish to web">
              <Button
                className="analyse-document"
                type="one"
                data-test="quotation-draft-btns-share"
                onClick={this.showShareOptions}>
                <FontAwesomeIcon
                  icon={["far", "share-alt"]}
                  className="documentrecipientlist-role-icon"
                />
              </Button>
            </Tooltip>
            {this.state.showShareOptions && (
              <div className="export-dropdown sending-docs">
                <ul className="export-dd-items">
                  <Tooltip
                    placement="left"
                    overlay="Any <b>changes</b> made on the <b>document gets updated</b> on the magic link."
                    imgUrl={MAGICLINK_PNG}
                    imgAltTxt="send-for-acceptance">
                    <li>
                      <div
                        data-test="share-magic-link"
                        className="send-list-item"
                        role="button"
                        tabIndex="0">
                        <div className="btn-send-icon">
                          <FontAwesomeIcon
                            icon={["far", "globe"]}
                            className="documentrecipientlist-role-icon"
                          />
                        </div>
                        <div>
                          <div className="btn-send-heading">
                            Share a magic link
                          </div>
                          <div className="btn-send-desc">
                            Copy shareable link with a live view of document
                          </div>
                        </div>
                        <div className="btn-share-toggle revv-perma-toggle">
                          <Input
                            data-test="input-revv-inp-checkbox-or-radio"
                            className=" docsharingpopup-sharingform-col"
                            isSwitch
                            type="checkbox"
                            onChange={() =>
                              this.props.checkToggleValue("copyLink")
                            }
                            value=""
                            checked={this.props.activeShare}
                          />
                        </div>
                      </div>
                      {this.props.activeShare &&
                        this.props.docPermaLink !== "" && (
                          <div className="permalink-wrapper">
                            <Input
                              ref={this.textInputRef}
                              type="text"
                              id="permaLinkCopy"
                              className="revv-inp"
                              value={this.props.docPermaLink}
                              placeholder="Generating link..."
                              disabled
                            />

                            <div className="copy-btn">
                              <Button
                                className="revv-btn-secondary"
                                onClick={() =>
                                  this._handleCopyLink(this.props.docPermaLink)
                                }
                                data-test="quotation-draft-btns-copy">
                                Copy
                              </Button>
                            </div>
                          </div>
                        )}
                    </li>
                  </Tooltip>
                  {!this.props.isPdfDocument && (
                    <Tooltip
                      placement="left"
                      overlay="The <b>snap link</b> will be a <b>timestamped</b> static <b>version</b> of the document."
                      imgUrl={SNAPLINK_PNG}
                      imgAltTxt="send-for-acceptance">
                      <li>
                        <div
                          data-test="share-snap-link"
                          className="send-list-item"
                          role="button"
                          tabIndex="0">
                          <div className="btn-send-icon">
                            <FontAwesomeIcon
                              icon={["far", "link"]}
                              className="documentrecipientlist-role-icon"
                            />
                          </div>
                          <div>
                            <div className="btn-send-heading">
                              Publish a snap link to web
                              <span className="save-doc-temp-new-tag">New</span>
                            </div>
                            <div className="btn-send-desc">
                              Get a search engine friendly link of your document
                              and share it anywhere.
                            </div>
                          </div>
                          <div className="btn-share-toggle revv-perma-toggle">
                            <Input
                              data-test="input-revv-inp-checkbox-or-radio"
                              className=" docsharingpopup-sharingform-col"
                              isSwitch
                              type="checkbox"
                              onChange={() =>
                                this.props.checkToggleValue("copySnapLink")
                              }
                              value=""
                              checked={this.props.activeSnapShare}
                            />
                          </div>
                        </div>
                        {this.props.activeSnapShare &&
                          this.props.docSnapLink !== "" && (
                            <div>
                              <div className="permalink-wrapper">
                                <Input
                                  ref={this.textInputRef}
                                  type="text"
                                  id="permaLinkCopy"
                                  className="revv-inp"
                                  value={this.props.docSnapLink}
                                  placeholder="Generating link..."
                                  disabled
                                />

                                <div className="copy-btn">
                                  <Button
                                    className="revv-btn-secondary"
                                    onClick={() =>
                                      this._handleCopyLink(
                                        this.props.docSnapLink,
                                      )
                                    }
                                    data-test="quotation-draft-btns-copy">
                                    Copy
                                  </Button>
                                </div>
                              </div>
                              <div className="snaplink-generated-info">
                                <span>
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={["far", "info-circle"]}
                                  />
                                </span>
                                <span>
                                  {" "}
                                  {ReactHtmlParser(
                                    snaplinkGeneratedInfo(
                                      this.props.docSnapLinkCreatedAt,
                                    ),
                                  )}
                                </span>
                              </div>
                            </div>
                          )}
                      </li>
                    </Tooltip>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div>
          <div className="btn-export-wrapper" ref={this.createExportRef}>
            <Tooltip placement="bottom" overlay="More">
              <Button
                className="analyse-document"
                data-test="quotation-draft-btns-more"
                type="one"
                onClick={this.showMoreOptions}>
                <FontAwesomeIcon
                  icon={["far", "ellipsis-v"]}
                  className="documentrecipientlist-role-icon"
                />
              </Button>
            </Tooltip>
            {this.state.showMoreOptions && (
              <div className="export-dropdown sending-docs">
                <ul className="export-dd-items">
                  <li>
                    <div className="send-list-section-heading">
                      <div className="send-list-section-div">
                        {" "}
                        DOCUMENT ACTIONS
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      className="send-list-item"
                      data-test="cta-send-to-someone-button"
                      role="button"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("editDocument")}
                      onKeyPress={() => this._handleOptionList("editDocument")}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "pen-square"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading">Edit document</div>
                        <div className="btn-send-desc">
                          Unlock and re-edit document, make changes and resend
                        </div>
                      </div>
                    </div>
                  </li>
                  <div className="divide-line" />
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="download-doc-stage-btn"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("download")}
                      onKeyPress={() => this._handleOptionList("download")}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "download"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading">
                          Download document
                        </div>
                        <div className="btn-send-desc">
                          Download a PDF of this document
                        </div>
                      </div>
                    </div>
                  </li>
                  {!this.props.isPdfDocument && (
                    <li>
                      <div
                        className="send-list-item"
                        role="button"
                        data-test="cta-preview-document-button"
                        tabIndex="0"
                        onClick={this._toggleDocPreviewPopUp}
                        onKeyPress={() => {}}>
                        <div className="btn-send-icon">
                          <FontAwesomeIcon
                            icon={["far", "eye"]}
                            className="documentrecipientlist-role-icon"
                          />
                        </div>
                        <div>
                          <div className="btn-send-heading">
                            {" "}
                            Preview document
                          </div>
                          <div className="btn-send-desc">
                            See a PDF preview of document
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="cta-send-for-metalense-button"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("metalense")}
                      onKeyPress={() => this._handleOptionList("metalense")}>
                      <div className="btn-send-icon">
                        {/* <FontAwesomeIcon
                          icon={["far", "microscope"]}
                          className="documentrecipientlist-role-icon"
                        /> */}
                        <QuickReviewIcon />
                      </div>
                      <div>
                        <div className="btn-send-heading">Enable Metalens</div>
                        <div className="btn-send-desc">
                          Use A.I to analyze document for critical data
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="send-list-section-heading">
                      <div className="send-list-section-div">
                        {" "}
                        REUSE THIS DOCUMENT
                      </div>
                    </div>
                  </li>
                  {!this.props.isPdfDocument &&
                    CURRENT_USER &&
                    CURRENT_USER.roles &&
                    CURRENT_USER.roles.length > 0 &&
                    CURRENT_USER.roles[0].name === "Admin" && (
                      <DocToTemplateBtn
                        togglePopup={this.toggleDocToTemplatePopup}
                      />
                    )}
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="cta-clone-document-button"
                      tabIndex="0"
                      onClick={this._cloneDocument}
                      onKeyPress={() => {}}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "clone"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading"> Clone document</div>
                        <div className="btn-send-desc">
                          Create a copy and reuse the document as needed
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="send-list-section-heading">
                      <div className="send-list-section-div">
                        {" "}
                        OTHER ACTIONS
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="cta-send-for-invite-button"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("invite")}
                      onKeyPress={() => this._handleOptionList("invite")}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "user-plus"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading">
                          Invite a teammate to Revv
                        </div>
                        <div className="btn-send-desc">
                          Invite colleagues to join you on Revv and work
                          together
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="cta-send-for-refer-button"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("reffer")}
                      onKeyPress={() => this._handleOptionList("reffer")}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "gift"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading">
                          Refer someone and get benefits
                        </div>
                        <div className="btn-send-desc">
                          Refer businesses, consultants and peers to get Amazon
                          gift cards
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        {/* <ExportDocumentBtn docStatus={this.props.docStatus} />
        <Button
          className="analyse-document"
          onClick={() =>
            this.props.togglePopUp("showConfirmMoveToDraftPopup", true)
          }
          id={"EditBtnWithRbac".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationTopbar-upgrade-stage-btn">
          Edit document
        </Button> */}
        {/* <UploadRevision {...this.props} /> */}
        {/* {this._getCustomerReviewDropdown()} */}
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  updateToolPaneData,
};

export default connect(
  null,
  mapDispatchToProps,
)(QuotationApprovedBtns);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/QuotationApprovedBtns.js